module.exports = __WEBPACK_EXTERNAL_MODULE_openfl_display3D_textures_VideoTexture__;